import Axios from './Axios';
import axios from 'axios';
import authHeader from './auth-header';

const API_URL = process.env.VUE_APP_API_URL;

class VmsService {
  inviteAssist(payload) {
    return Axios({
      method: 'post',
      url: 'vms/ai/invite-assist',
      data: payload,
    });
  }

  visitRisk(visitId) {
    return Axios({
      method: 'get',
      url: `vms/visits/${visitId}/risk`,
    });
  }

  approvalBriefing(visitId) {
    return Axios({
      method: 'get',
      url: `vms/visits/${visitId}/approval-briefing`,
    });
  }

  decisionDraft(visitId, payload = {}) {
    return Axios({
      method: 'post',
      url: `vms/visits/${visitId}/decision-draft`,
      data: payload,
    });
  }

  duplicateCheck(payload) {
    return Axios({
      method: 'post',
      url: 'vms/ai/duplicate-check',
      data: payload,
    });
  }

  suggestCategory(payload) {
    return Axios({
      method: 'post',
      url: 'vms/ai/suggest-category',
      data: payload,
    });
  }

  rewriteNotification(payload) {
    return Axios({
      method: 'post',
      url: 'vms/ai/rewrite-notification',
      data: payload,
    });
  }

  parseVisitSearch(payload) {
    return Axios({
      method: 'post',
      url: 'vms/ai/parse-visit-search',
      data: payload,
    });
  }

  postVisitSummary(visitId) {
    return Axios({
      method: 'get',
      url: `vms/visits/${visitId}/post-summary`,
    });
  }

  policyAnswer(payload) {
    return Axios({
      method: 'post',
      url: 'vms/ai/policy-answer',
      data: payload,
    });
  }

  badgeUrl(visitId) {
    return `${API_URL}vms/visits/${visitId}/badge`;
  }

  openBadge(visitId) {
    const url = this.badgeUrl(visitId);
    return axios
      .get(url, {
        headers: authHeader(),
        responseType: 'text',
      })
      .then((response) => {
        const blob = new Blob([response.data], { type: 'text/html' });
        const blobUrl = URL.createObjectURL(blob);
        window.open(blobUrl, '_blank');
        return response;
      });
  }

  openBadgeJson(visitId) {
    return axios
      .get(this.badgeUrl(visitId) + '?json=1', { headers: authHeader() })
      .then((response) => response?.data?.data?.invite_url || null);
  }

  guestInviteUrl(token) {
    const origin = window.location.origin;
    return `${origin}/guest/${token}`;
  }

  publicShow(token) {
    return axios.get(`${API_URL}public/visits/${token}`);
  }

  publicConfirm(token, payload) {
    return axios.post(`${API_URL}public/visits/${token}/confirm`, payload);
  }

  ensureInviteLink(item) {
    if (item?.guest_token) {
      return this.guestInviteUrl(item.guest_token);
    }
    if (item?.invite_url) {
      return item.invite_url;
    }
    return null;
  }
}

export default new VmsService();
